// removed by extract-text-webpack-plugin
module.exports = {"moduleSection":"c6LufICZ4ZYzxE02ABedu","clientContractZoomContainer":"_31aeAl9zpfINLOS08uCvKZ","iconContainer":"_3ZHc8R_BBmSYl17y2pd30G"};


//////////////////
// WEBPACK FOOTER
// ./components/b2bCompany/b2bCompanyClientContracts.scss
// module id = 1587
// module chunks = 0